import { useEffect, useState } from "react";
import { useBillInsuranceActivationModal } from "@hooks/useBillInsuranceActivationModal";
import { useModalStore } from "@store/modal/modal";
import { useChubbBillInsurancesQuery } from "@services/insurance/queries";
import { ChubbInsuranceModal } from "./ChubbInsuranceModal";

export const useChubbInsuranceModal = () => {
  const [modalId, setModalId] = useState(0);

  const { create, remove } = useModalStore();
  const { openBillInsuranceActivationModal } =
    useBillInsuranceActivationModal();

  const { data: chubbBillInsurancesData } = useChubbBillInsurancesQuery();

  useEffect(() => {
    if (
      modalId &&
      !chubbBillInsurancesData?.jointBillService.some(
        (jbs) => jbs.insuranceStatus,
      )
    ) {
      setModalId(0);
      remove(modalId);
    }
  }, [modalId, chubbBillInsurancesData, remove]);

  const openChubbInsuranceModal = () => {
    if (!chubbBillInsurancesData) {
      return;
    }

    const chubbInsuranceModalId = create((modalProps) => (
      <ChubbInsuranceModal
        openBillInsuranceActivationModal={openBillInsuranceActivationModal}
        {...modalProps}
      />
    ));

    setModalId(chubbInsuranceModalId);
  };

  return { openChubbInsuranceModal };
};
